import { useState, useEffect } from 'react'
import notification from '@/components/notification'
import { copyContent } from 'core/utils/clipboard'
import { useLocale } from 'core/components/Locale'

/**
 * 自定义 Hook：useCopy
 * 复制内容并显示成功消息
 * @returns {Function} copyTextWithNotification - 复制文本并显示通知的函数
 */
export const useCopy = () => {
  const t = useLocale()

  const copyTextWithNotification = (text: string, msg?: string): void => {
    copyContent(text)
    const message = msg || t('header_026')

    notification.success({
      message,
      duration: 3500,
      position: 'top',
    })
  }

  return { copyTextWithNotification }
}
